import { Component } from '@angular/core';
import { UserService } from '../../services/http/user.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent {
  oldPassword : string = ""
  newPassword : string = ""
  newPasswordRepeated : string = ""
  public showPw1: boolean = false;
  public showPw2: boolean = false;
  public showPw3: boolean = false;

  constructor(private userService: UserService, private toastr: ToastrService, private router : Router){

  }

  validatePass(){
    if (this.newPassword?.length < 8) {
      this.toastr.error("Password must be at least 8 characters");
      return false;
    }
    if (this.newPassword?.search(/[$&+,:;=?@#|'<>.^*()%!-]/) < 0) {
      this.toastr.error("Password must contain at least one special character ($&+,:;=?@#|'<>.^*()%!-).");
      return false;
    }
    if (this.newPassword.search(/[A-Z]/) <0) {
      this.toastr.error("Password must contain at least one Uppercase letter.");
      return false;
    }  
    if (this.newPassword.search(/[a-z]/) <0) {
      this.toastr.error("Password must contain at least one Lowercase letter.");
      return false;
    }  
    if (this.newPassword?.search(/[0-9]/) < 0) {
      this.toastr.error("Password must contain at least 1 number.");
      return false;
    }
    if (this.newPassword != this.newPasswordRepeated) {
      this.toastr.error("Passwords must match");
      return false;
    }
    return true;
  }

  changePassword(){
    if(!this.validatePass())
      return;

    let obj = {
      oldPassword: this.oldPassword,
      newPassword: this.newPassword
    }
    this.userService.changePassword(obj).subscribe(response => {
      if(response.status == 200){
        this.toastr.success(response.message);
        this.router.navigate(['']);}
      else
        this.toastr.error(response.message);
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  showPassword(fieldNo : number) {
    if(fieldNo == 1)
      this.showPw1 = !this.showPw1;
    if(fieldNo == 2)
      this.showPw2 = !this.showPw2;
    if(fieldNo == 3)
      this.showPw3 = !this.showPw3;
  }
}
